import { Component } from '@angular/core';

import {AlertController, NavController, ToastController} from 'ionic-angular';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../../providers/user-data';
import {Observable} from "rxjs/Observable";
import {MissionsListPage} from "../../missions/missions-list/missions-list";
import {UiData} from "../../../providers/ui-data";

@Component({
    selector: 'page-ranking',
    templateUrl: 'ranking.html'
})
export class RankingPage {

    lastChangedCriteria:string = "ponctuality";
    criterias: any;
    active: any = -1;
    rankings: any = [];
    settings: any;
    grid:any;
    sessionRef: any;
    userRef: any;
    total: any;
    max: any = 20;
    advertised:boolean = false;
    displayName: string ="";
    displayName2: string ="";
    displayNote: any ="";

    constructor(
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public toastCtrl: ToastController,
        public afDatabase: AngularFireDatabase,
        public uiData: UiData
    ) {
        this.criterias = ['ponctuality','motivation','adaptation','autonomie','professionnalisme'];
        this.settings = {
            "ponctuality" : {
                "label":"Ponctualité",
                "description":"Estimez votre capacité à être ponctuel, présent et digne de confiance.",
                "note":3
            },
            "motivation" : {
                "label":"Motivation",
                "description":"Notez votre capacité de motivation personnelle pour la réalisation du travail demandé dans le cadre des missions.",
                "note":3
            },
            "adaptation" : {
                "label":"Adaptation",
                "description":"Estimez votre capacité d'adaptation et d'apprentissage, face à des situations ou des tâches inconnues.",
                "note":3
            },
            "autonomie" : {
                "label":"Autonomie",
                "description":"Etes vous autonome dans la réalisation d'une mission ? Estimez vos capacités à travailler en autonomie.",
                "note":3
            },
            "professionnalisme" : {
                "label":"Professionalisme",
                "description":"Estimez votre niveau de professionalisme dans votre domaine d'activité. <br/>Le professionalisme est un mélange de votre niveau d'expérience et de votre capacité d'application.",
                "note":3
            },
        };
        this.grid = {
            "ponctuality" : 1,
            "motivation" : 1,
            "adaptation" : 1,
            "autonomie" : 1,
            "professionnalisme" : 1,
        };
    }

    setActive(i){
        this.active = i;
    }
    ionViewDidLoad() {
        this.getUserInfos();

    }
    ionViewWillUnload() {

        this.sessionRef.unsubscribe();
        this.userRef.unsubscribe();
    }

    getUserInfos() {
        var that = this;
        that.sessionRef = that.userData.userSession().subscribe(session => {
            if(session!==null) {
                that.userRef =that.userData.load().subscribe(user => {
                    if(that.userData.get('ranking'))
                    {
                        if(that.userData.get('ranking').grid)
                            that.grid = that.userData.get('ranking').grid;
                        if(that.userData.get('ranking').rankings)
                            that.rankings = that.userData.get('ranking').rankings;
                    }
                    let civility = that.userData.get('civility');
                    let ranking = that.userData.get('ranking');
                    let availability = that.userData.get('availability');

                    if (civility && civility.prenom && civility.nom) {
                        that.displayName = civility.prenom+" "+civility.nom ;
                        that.displayName2 = civility.email;
                    }
                    else if (civility && civility.prenom) {
                        that.displayName = civility.prenom ;//+ ' ' + civility.nom
                        that.displayName2 = civility.email;
                    }
                    else if(civility && civility.email) {
                        that.displayName = civility.email.split('@')[0];
                        that.displayName2 = civility.email;
                    }
                    if(ranking && ranking.note)
                    {
                        that.displayNote = Math.round(ranking.note/5*100)/100;
                    }

                    that.refresh();
                });
            }
        });
    }
    openDescription(criteria)
    {
        // create an alert instance
        let alert = this.alertCtrl.create({
            title: this.settings[criteria].label,
            message: this.settings[criteria].description,
            buttons: [{
                text: 'Compris !',
                handler: () => {
                    // close the sliding item
                }
            }]
        });
        // now present the alert on top of all other content
        alert.present();
    }
    save()
    {
        this.userData.set('ranking',{
            'note':this.total,
            'grid':this.grid,
            'ok':true,
        });
        this.presentToast('Votre évaluation a été enregistrée. Merci.')
        this.nav.setRoot(this.userData.loggedInDestination());

    }
    private presentToast(text) {
        let toast = this.toastCtrl.create({
            message: text,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }
    later()
    {
        for(let i=0;i<this.criterias.length;i++)
        {
            this.grid[this.criterias[i]]=3;
        }
        this.refresh();
        this.userData.set('ranking',{
            'note':this.total,
            'grid':this.grid,
            'ok':false,
        });
        this.nav.setRoot(MissionsListPage);

    }
    refresh()
    {
        let cc = 0;
        for(let i=0;i<this.criterias.length;i++)
        {
            cc+=this.grid[this.criterias[i]];
        }
        this.total = cc;
        if(this.total>this.max)
        {
            if(!this.advertised)
            {
                this.advertised=true;
                let prompt = this.alertCtrl.create({
                    title: '',
                    message: "Pour cette évaluation personnelle, vous disposez de "+this.max+" étoiles à répartir sur 5 critères d\'évaluation. <br/><br/>Vous ne pouvez pas en attribuer davantage.",
                    buttons: [
                        {
                            text: "J'ai compris",
                            handler: data => {


                            }
                        }
                    ]
                });
                prompt.present();
            }
            var dif = this.total-this.max;
            var criteria_to_reduce = this.getCriteriaToReduce();
            if(this.grid[criteria_to_reduce]>0)
            {
                this.grid[criteria_to_reduce]--;
            }
            this.lastChangedCriteria = criteria_to_reduce;
            this.refresh();
        }
    }
    getCriteriaToReduce()
    {
        var current_index = this.criterias.indexOf(this.lastChangedCriteria);
        current_index++;
        if(current_index>=this.criterias.length)
        {
            current_index = 0;
        }
        return this.criterias[current_index];
    }
    note(criteria,note)
    {
        this.grid[criteria]=note;
        this.lastChangedCriteria = criteria;
        this.refresh();
    }

}



// WEBPACK FOOTER //
// ./src/pages/account/ranking/ranking.ts